import React, { useState } from "react";
import Box from "@mui/material/Box";
import PublicLayoutAppBar from "./components/PublicLayoutAppbar";
import { styled, useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import SetupDialog from "src/pages/dashboard/SetupDialog";
import SubscriptionPlanDialog from "src/@core/components/SubscriptionPlanDialog";
import PaymentSuccessDialog from "src/@core/components/PaymentSuccessDialog";
import PaymentErrorDialog from "src/@core/components/PaymentErrorDialog";
import BusinessDeactivationDialog from "src/@core/components/BusinessDeactivationDialog";

// Constants
const SIDEBAR_WIDTH_EXPANDED = 350;
const SIDEBAR_WIDTH_COLLAPSED = 0;

// Routes that should use Dialog instead of Sidebar
const DIALOG_ROUTES = ["/dashboard", "/chats"];

const PublicLayoutWrapper = styled(Box)(({ theme }) => ({
  height: "100vh",
  overflow: "hidden",
}));

const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'toolbarHeight',
})(({ theme, sidebarExpanded, useDialog, toolbarHeight }) => ({
  position: "absolute",
  top: `${toolbarHeight}px`,
  left: useDialog
    ? 0
    : sidebarExpanded
    ? SIDEBAR_WIDTH_EXPANDED
    : SIDEBAR_WIDTH_COLLAPSED,
  transition: useDialog ? "none" : "left 0.3s ease-in-out",
  width: useDialog
    ? "100%"
    : sidebarExpanded
    ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED}px)`
    : "100%",
  height: `calc(100vh - ${toolbarHeight}px)`,
  overflowY: "auto",
  overflowX: "hidden",
  backgroundColor: "#FFFFFF",
}));

const PublicLayout = (props) => {
  const { children } = props;
  const theme = useTheme();
  const location = useLocation();
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  // Determine if current route should use dialog
  const shouldUseDialog = DIALOG_ROUTES.includes(location.pathname);

  // Get the toolbar height from theme
  const toolbarHeight = theme.mixins.toolbar.minHeight || 56;

  const handleSidebarToggle = (isExpanded) => {
    // Only update sidebar state if not using dialog
    if (!shouldUseDialog) {
      setSidebarExpanded(isExpanded);
    }
  };

  return (
    <PublicLayoutWrapper>
      <PublicLayoutAppBar
        onSidebarToggle={handleSidebarToggle}
        useSidebarDialog={shouldUseDialog}
      />
      <SubscriptionPlanDialog />
      <BusinessDeactivationDialog />
      <SetupDialog />
      <PaymentSuccessDialog />
      <PaymentErrorDialog />

      <ContentWrapper
        id="publicLayoutScroll"
        sidebarExpanded={sidebarExpanded}
        useDialog={shouldUseDialog}
        toolbarHeight={toolbarHeight}
      >
        {children}
      </ContentWrapper>
    </PublicLayoutWrapper>
  );
};

export default PublicLayout;
